import {
  ArrowRight,
  Globe2,
  Map,
  MapPin,
  MessageCircle,
  PlayCircle,
  Waves,
} from "lucide-react";

const TOUR_360 = "https://storage.net-fs.com/hosting/8464171/0/";
const FACEBOOK = "https://www.facebook.com/PuertoSCZresort/";
const TIKTOK = "https://www.tiktok.com/@puertosantacruz";
const WHATSAPP = "https://wa.me/59177987826?text=Hola%2C%20estoy%20viendo%20el%20proyecto%20Puerto%20Santa%20Cruz%20y%20quisiera%20recibir%20informaci%C3%B3n";
const LOCATION = "https://maps.app.goo.gl/wB8bE4JUkjPSRxrC6";

const gallery = [
  {
    image: "/landing/experiencia-lago.jpg",
    title: "Experiencias sobre el agua",
    text: "Navegación, atardeceres y momentos para disfrutar.",
  },
  {
    image: "/landing/jetski.jpg",
    title: "Disfruta y desconecta",
    text: "Deporte acúatico para compartir con familia y amigos.",
  },
  {
    image: "/landing/naturaleza.jpg",
    title: "Naturaleza",
    text: "Un entorno donde el verde y el agua son protagonistas.",
  },
  {
    image: "/landing/piscinas.jpg",
    title: "Momentos inolvidables",
    text: "Experiencias para todas las generaciones.",
  },
  {
    image: "/landing/aventura.jpg",
    title: "Aventura",
    text: "Actividades para quienes buscan algo diferente.",
  },
  {
    image: "/landing/cabalgata.jpg",
    title: "Vida al aire libre",
    text: "Descubre otra forma de disfrutar tu tiempo.",
  },
];

export default function ProjectIntroLanding({
  onViewPlan,
}) {
  return (
    <div className="psc-project-landing">

      {/* =====================================================
          HERO
          ===================================================== */}

      <section className="psc-landing-hero">

        <img
          className="psc-landing-hero-image"
          src="/landing/hero.jpg"
          alt="Puerto Santa Cruz Yacht Club Resort"
        />

        <div className="psc-landing-hero-overlay" />

        <div className="psc-landing-hero-content">
<img
  src="/puerto-santa-cruz-logo.png"
  alt="Puerto Santa Cruz Yacht Club Resort"
  className="psc-landing-hero-logo"
/>
          <div className="psc-landing-brand">
            PUERTO SANTA CRUZ
            <span>YACHT CLUB RESORT</span>
          </div>

          <div className="psc-landing-hero-line" />

          <h1>
            Donde la naturaleza
            <br />
            se convierte en
            <span> experiencias.</span>
          </h1>

          <p>
            Descubre un lugar pensado para vivir,
            disfrutar y compartir momentos
            inolvidables junto al agua.
          </p>


        </div>

        <div className="psc-landing-scroll">
          <span>DESCUBRE EL PROYECTO</span>
          <span className="psc-landing-scroll-line" />
        </div>

      </section>


      {/* =====================================================
          INTRO
          ===================================================== */}

      <section className="psc-landing-intro">

        <div className="psc-landing-section-label">
          PUERTO SANTA CRUZ
        </div>

        <h2>
          Un proyecto para
          <span> vivirlo.</span>
        </h2>

        <p className="psc-landing-intro-text">
          Puerto Santa Cruz Yacht Club Resort combina
          naturaleza, agua, espacios recreativos y
          experiencias para crear un lugar diferente
          para vivir y disfrutar.
        </p>

        <div className="psc-landing-stats">

          <div>
            <strong>245</strong>
            <span>hectáreas</span>
          </div>

          <div>
            <strong>4</strong>
            <span>lagunas</span>
          </div>

          <div>
            <strong>∞</strong>
            <span>experiencias</span>
          </div>

        </div>

      </section>


      {/* =====================================================
          EXPERIENCIAS
          ===================================================== */}

      <section className="psc-landing-experiences">

        <div className="psc-landing-section-heading">

          <div>
            <span className="psc-landing-section-label">
              EXPERIENCIAS
            </span>

            <h2>
              Mucho más que
              <span> un terreno.</span>
            </h2>
          </div>

          <p>
            Aquí el espacio se convierte en
            experiencias para compartir.
          </p>

        </div>


        <div className="psc-landing-gallery">

          {gallery.map((item, index) => (
            <article
              key={item.image}
              className={
                index === 0
                  ? "psc-landing-gallery-card psc-landing-gallery-featured"
                  : "psc-landing-gallery-card"
              }
            >

              <img
                src={item.image}
                alt={item.title}
                loading={index > 1 ? "lazy" : "eager"}
              />

              <div className="psc-landing-gallery-overlay" />

              <div className="psc-landing-gallery-content">

                <span>
                  0{index + 1}
                </span>

                <h3>
                  {item.title}
                </h3>

                <p>
                  {item.text}
                </p>

              </div>

            </article>
          ))}

        </div>

      </section>

      {/* =====================================================
          ACCIONES
          ===================================================== */}

      <section className="psc-landing-actions">

        <div className="psc-landing-actions-heading">

          <span className="psc-landing-section-label">
            CONOCE MÁS
          </span>

          <h2>
            Puerto Santa Cruz
            <span> está esperando por ti.</span>
          </h2>

        </div>


        <div className="psc-landing-action-grid">

          <a
            href={TOUR_360}
            target="_blank"
            rel="noreferrer"
            className="psc-landing-action psc-landing-action-tour"
          >
            <PlayCircle size={25} />

            <div>
              <strong>
                Tour 360°
              </strong>

              <span>
                Recorre el proyecto virtualmente
              </span>
            </div>

            <ArrowRight size={19} />
          </a>


          <a
            href={WHATSAPP}
            target="_blank"
            rel="noreferrer"
            className="psc-landing-action"
          >
            <MessageCircle size={25} />

            <div>
              <strong>
                Contactarnos
              </strong>

              <span>
                Habla directamente con nosotros
              </span>
            </div>

            <ArrowRight size={19} />
          </a>


          <a
            href={LOCATION}
            target="_blank"
            rel="noreferrer"
            className="psc-landing-action"
          >
            <MapPin size={25} />

            <div>
              <strong>
                Ubicación
              </strong>

              <span>
                Encuentra Puerto Santa Cruz
              </span>
            </div>

            <ArrowRight size={19} />
          </a>

        </div>


        <div className="psc-landing-social">

          <span>
            Síguenos
          </span>

          <a
            href={FACEBOOK}
            target="_blank"
            rel="noreferrer"
          >
            Facebook
          </a>

          <a
            href={TIKTOK}
            target="_blank"
            rel="noreferrer"
          >
            TikTok
          </a>

        </div>


        <button
          type="button"
          className="psc-landing-bottom-plan"
          onClick={onViewPlan}
        >
          <Map size={18} />
          Ver plano interactivo
        </button>

      </section>


      {/* =====================================================
          FOOTER
          ===================================================== */}

      <footer className="psc-landing-footer">
        <strong>
          PUERTO SANTA CRUZ
        </strong>

        <span>
          YACHT CLUB RESORT
        </span>

        <small>
          Vive. Disfruta. Comparte.
        </small>
      </footer>

    </div>
  );
}
